// Local storage keys
export const SURVEY_SELECTION_SORT_BY = 'surveySelectionSortBy';
